import React from "react";
import { Column, ColumnId } from ".";
import ExecutorCallStatusCellContent from "../components/ExecutorCallStatusCellContent";
import base from "./base";

function executorCallStatus({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ExecutorCallStatus,
		(item) => <ExecutorCallStatusCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executorCallStatus;
